import { useEffect, useState } from 'react';
import footerImage from '../Images/logo-no-background.png'
import { Link } from 'react-router-dom';

function Footer(props) {
    const [count, setCount] = useState(0);
    useEffect(() => {
        getData();
    }, [])
    function getData() {
        fetch('https://api.api-ninjas.com/v1/counter?id=localhost:3000&hit=true', {
            method: 'GET',
            headers: {
                'X-Api-Key': 'Ys1hX9Drm6rQBL8cHSjNng==KVITmUq86v9ZzVcJ'
            },
        })
            .then(function (response) {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.text();
            })
            .then(function (body) {
                var temp = JSON.parse(body);
                setCount(temp.value)
            })
            .catch(function (error) {
                console.error('Request failed:', error);
            });
    }

    return (
        <div className="container-fluid" style={{ backgroundColor: props.BGColor === "#DEF2F1" ? "#17252A" : "#DEF2F1", color: !props.color === "#2B7A78" ? "#2B7A78" : "#3AAFA9" }} >
            <div className="container container-sm">
                <footer className="pt-5">
                    <div className="row">
                        <div className="col-6 col-md-3 mb-3">
                            <div className="container" >
                                <img src={footerImage} alt="" className='img-thumbnail border-0' style={{ backgroundColor: props.BGColor === "#DEF2F1" ? "#17252A" : "#DEF2F1" }} />
                            </div>
                        </div>

                        <div className="col-6 col-md-4 mb-3 px-5" >
                            <div className="container">
                                <h5>NovaCop's Scammer Patil</h5>
                                <ul className="nav flex-column">
                                    <li className="nav-item mb-2" ><Link to="/" className={`nav-link p-0 text-${props.mode === "dark" ? "dark" : "light"}`}>Home</Link></li>
                                    <li className="nav-item mb-2" ><Link to="/about" className={`nav-link p-0 text-${props.mode === "dark" ? "dark" : "light"}`}>About Me</Link></li>
                                    <li className="nav-item mb-2" ><Link to="/project" className={`nav-link p-0 text-${props.mode === "dark" ? "dark" : "light"}`}>My Project</Link></li>
                                    <li className="nav-item mb-2" ><Link to="/skills" className={`nav-link p-0 text-${props.mode === "dark" ? "dark" : "light"}`}>My Skills</Link></li>
                                    <li className="nav-item mb-2" ><Link to="/contactme" className={`nav-link p-0 text-${props.mode === "dark" ? "dark" : "light"}`}>Contact</Link></li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-md-4 offset-md-1 mb-3 py-3" >
                            <form action='https://docs.google.com/forms/d/e/1FAIpQLSdfJipR2terw07gYbhBG7AfPSyc_lUP6gDRIU1ChuRJ5ey0oA/formResponse' method="post">
                                <h5>Subscribe to our newsletter</h5>
                                <p>Monthly digest of what's new and exciting from us.</p>
                                <div className="d-flex flex-column flex-sm-row w-100 gap-2">
                                    <label htmlFor="newsletter1" className="visually-hidden">Email address</label>
                                    <input id="newsletter1" type="text" name='entry.469799215' className="form-control" placeholder="Email address" />
                                    <button className="btn" style={{ backgroundColor: props.BGColor, color: props.color }} type="submit">Subscribe</button>
                                </div>
                                <p className='py-3'>
                                    <span>Number of Visitor: {count}</span>
                                </p>
                            </form>
                        </div>
                    </div>

                    <div className="d-flex flex-column flex-sm-row justify-content-between pt-4 mt-4" style={{ borderTop: "1px solid", borderTopColor: props.color }}>
                        <p>&copy; 2022 Company, Inc. All rights reserved.</p>
                        <ul className="list-unstyled d-flex">
                            <li className="ms-3"><a className="link-dark" target='_blank' rel='noreferrer' href="https://twitter.com/Scammerpatil"><ion-icon name="logo-twitter" style={{ color: !props.color === "#2B7A78" ? "#2B7A78" : "#3AAFA9" }}></ion-icon></a></li>
                            <li className="ms-3"><a className="link-dark" target='_blank' rel='noreferrer' href="https://instagram.com/its_sauravpatil"><ion-icon name="logo-instagram" style={{ color: !props.color === "#2B7A78" ? "#2B7A78" : "#3AAFA9" }}></ion-icon></a></li>
                            <li className="ms-3"><a className="link-dark" target='_blank' rel='noreferrer' href="https://github.com/Scammerpatil"><ion-icon name="logo-github" style={{ color: !props.color === "#2B7A78" ? "#2B7A78" : "#3AAFA9" }}></ion-icon></a></li>
                        </ul>
                    </div>
                </footer>
            </div>
        </div>
    )
}

export default Footer
